const message = {
    company: "Perusahaan",
    department: "Departemen",
    directorate: "Direktorat",
    division: "Divisi",
    employee: "Karyawan",
    functional: "Functional",
    grade: "Golongan",
    jobStatus: "Status Kerja",    
    lookup: "Lookup",
    position: "Posisi",
    section: "Section",
    superior: "Approval (Atasan)",
    unit: "OU (Unit)",
    user:"User",
    group: "Group",
    menu: "Menu",
    role: "Role",    
    business: "Bisnis",   
    region: "Region", 
    active: "Aktif",   
    name6up: "Nama (Grade 6Up)",
    fortable: "Fortable",
    rank: "Pangkat",
    birthdate: "Tanggal Lahir",
    workdate: "Tanggal Mulai Bekerja",    
    superior1: "Superior",
    nik_superior1: "NIK Superior",    
    superior2: "Head Superior",
    nik_superior2: "NIK Head Superior",    
    pic: "Nama PIC",    
    inactive_account: "Akun ini tidak aktif",   
    receive_notification: "Terima Pemberitahuan",    
    appraisal_year: "Tahun Appraisal",
    appraisal: "Penilaian",    
    employee_data: "Data Karyawan",    
    emp_name: "Nama Karyawan",
    EPA: "Penilaian Kinerja Karyawan",    
    warning_letter_period: "SP / Period",
    appraisal_period: "Periode Penilaian",
    comment_review: "Komentar Penilai",    
    company_name: "Nama Perusahaan",    
    company_desc: "Nama Lengkap Perusahaan",
    dept_name: "Nama Departemen",    
    directorate_name: "Nama Direktorat",    
    division_name: "Nama Divisi",    
    functional_name: "Nama Functional",    
    business_unit: "Business Unit",    
    ou_name: "Nama OU",    
    region_code: "Kode Region",   
    period_History: "Tahun Periode",  
    cut_off: "Cut Off",
    valid_from: "Valid Dari",
    valid_to: "Valid Sampai",
    semester: "Semester",
    pembobotan: "Pembobotan",    
    rating: "Bobot",    
    total_score: "Total Score",   
    objective: "Sasaran & Ukuran Keberhasilan",
    achieve: "Pencapaian",
    evaluate: "Evaluasi & Feedback",
    point: "Nilai",    
    job_status_name: "Nama Status Kerja",    
    section_name: "Nama Section",   
    position_name: "Nama Posisi",   
    name: "Nama",
    year: "Tahun",
    s_edit: "Edit By Superior",
    s_date: "Edit Date Superior",    
    h_edit: "Edit By H. Superior",
    h_date: "Edit Date H. Superior",        
    company_all: "Semua Perusahaan",
    functional_all: "Semua Functional",
    grade_all: "Semua Grade",
    unit_all: "Semua Unit",
    warning_letter: "SP (Surat Peringatan)",
    status_sp: "Status SP",
    period_sp: "Periode (Tanggal Mulai SP)",
    appraisal_reset: "Appraisal Data (Reset Penilaian)",    
    input_by: "Dibuat Oleh (User)",
    input_date: "Tgl. Pembuatan (User)",
    edit1_by: "Diubah Oleh (Superior)",
    edit1_date: "Tgl. Pengubahan (Superior)",
    edit2_by: "Diubah Oleh (Head Superior)",
    edit2_date: "Tgl. Pengubahan (Head Superior)",
    edit3_by: "Diubah Oleh (Komite)",
    edit3_date: "Tgl. Pengubahan (Komite)",    
    emp_number: "Username",
    code: "Kode",
    description: "Deskripsi",            
    nik: "NIK",
    created_by: "Dibuat Oleh",
    created_date: "Tgl. Pembuatan",
    edited_by: "Diubah Oleh",
    edited_date: "Tgl. Pengubahan",
    deleted_by: "Dihapus Oleh",
    deleted_date: "Tgl. Penghapusan",    
    is_deleted: "Hapus",
    rate: "Rate",
    period: "Period",  
    periodTo : "Period To",
    periodFrom : "Period From",  
    action: "Aksi",
    reset_confirmation: "Konfirmasi Reset",    
    promot_confirmation: "Konfirmasi Promosi",
    review_confirmation: "Konfirmasi Review",
    assesed_appraisal: "Daftar karyawan yang telah dinilai (Appraisal)",
    not_assesed_appraisal: "Daftar karyawan yang belum dinilai (Appraisal)",
    changelog: "Changelog",
    email: "Email",    
    username: "Username",
    full_name: "Nama",
    account: "Account",    
    is_required: "Value diperlukan",   
    create: "Create",    
    password: "Password",
    log_history: "Log Activity Penilaian (History)",    
    lookup_group: "Lookup Group",
    lookup_key: "Lookup Key",
    lookup_value: "Lookup Value",
    lookup_info1: "Info 1",
    lookup_info2: "Info 2",    
    version: "Versi",
    version_date: "Tanggal Versi",
    remark: "Keterangan",
    version_active: "Aktif Versi",    
    report_type: "Tipe Report",    
    ChangeOnTransaction: "Mengganti di transaksi ?",    
    userExc: "Pengecualian User",    
    clear: "Hapus",
    download_supporting_data: "Download Data Pendukung",
    use_ad: "Menggunakan AD",
    create_appraisal_notice: "Untuk create data appraisal baru,",
    click_here: "Klik disini",
    criteria: "Kriteria",
    range: "Jangkauan",
    standard: "Standar",
    summary: "Ringkasan",    
    grade_begin: "Tanggal Mulai Grade",    
    education: "Pendidikan",
    source: "Sumber",
    structure: "Deskripsi Struktur",    
    promotion_data: "Promotion Data",
    promotion_request: "Permintaan Promosi",
    tolerance_up: "Toleransi Atas",
    tolerance_down: "Toleransi Bawah",    
    promotion_status: "Permintaan Promosi",
    sync_confirmation: "Konfirmasi Sync",    
    score: "Score",
    status: "Status",
    lengthWork: "Masa Jabatan",
    lengthGrade: "Periode Golongan",  
    requested_date: "Tgl. Permintaan",    
    requested_by: "Diminta Oleh",    
    hrr: "HRR/PGA Head",
    effective_date: "Tgl. Effective",   
    reason: "Alasan",    
    new_position: "Posisi Baru",    
    reason_promot: "Alasan Promosi",  
    information: "Informasi",    
    promotion: "Promosi",    
    performance_period: "Periode Kinerja",
    nik_length: "NIK harus terdiri dari minimal 8 digit",
    sap_result_success: "dari total karyawan berhasil di sync",
    sap_result_failed: "dari total karyawan gagal di sync",
    user_level : "Level User",
    job_position : "Posisi Pekerjaan",
    contact : "Kontak",
    digital_sign : "Ttd Digital",
    contractor : "Kontraktor",
    release_matrix : "Rilis Matriks",
    location : "Lokasi",
    validity : "Validitas",
    type : "Tipe",
    category : 'Kategori',
    info1 : "Info 1",
    info2 : "Info 2",
    approval_as : "Approval As",
    level : "Level",
    module : "Module",
    budget_allocation : "Budget Allocation",  
    job_postion : "Posisi Pekerjaan", 
    approval : "Approval",
    company_contractor : "Kantor Kontraktor",
    last_approval_by : "Persetujuan Terakhir Oleh",
    last_approval_date : "Tanggal Persetujuan Terakhir",
    approval_confirmation : "Konfirmasi Persetujuan",
    contact_number : "Nomor Kontak",
    approval_by : "Disetujui Oleh",
    approval_date : "Tanggal Disetujui",
    area : "Area",
    cost_center : "WBS Alokasi",
    approve : "Approve",
    reject : "Reject",
    revisi : "Revise",
    release_approval : "Release Approval",
    adress : "Alamat",
    service_type : "Service Type",
    logo_contractor : "Logo Contractor",
    approval_master_data : "Approval Master Data",
    maindata : "Main Data",
    no_wo : "Nomor WO",
    no_spo : "Nomor SPO",
    job_desc : "Deskripsi Pekerjaan",
    no_spr :"Nomor SPR",
    no_spk : "Nomor SPK",
    contract_value : "Nilai Kontrak",
    budget :"WBS Alokasi",
    nilai_estimasi : "Nilai Estimasi",
    tanggal_mulai : "Tanggal Mulai",
    periode_kerja : "Periode Kerja",
    no : "No",
    doc_type:"Tipe Dokumen",
    process : "Proses",
    keterangan :"Keterangan",
    doc_date : "Tanggal Dokumen",
    doc_no : "Nomor Dokumen",
    spo_date : "Tanggal SPO",
    tanggal_mulai_pekerjaan : "Tanggal Mulai Pekerjaan",
    job_completion_time : "Waktu Penyelesaian Pekerjaan",
    pic_pm : "PIC Project Manager",
    pic_contractor : "PIC Contractor",
    pic_cp : "PIC Coordinator Project",
    scope : "Scope",
    all_company : "Semua Company",
    project : "Projek",
    meeting_no : "No Meeting",
    date_of_meeting : "Tanggal Meeting",
    meeting_room : "Ruangan Meeting",
    documentation : "Documentation",
    notes_issued_by : "Notes Issued By",
    notes : "Catatan",
    is_check : "Check",
    approved_by : "Approved By",
    issued_date : "Issued Date",
    user_type : "Tipe User",
    site_manager : "Site Manager",
    count_day :"Jumlah Hari",
    day_date :  "Hari/Tanggal",
    end_date : "Tanggal Selesai SPO/SPK",
    final_date : "Tanggal Final Inspeksi QC",
    count_delay_day : "Jumlah Hari Keterlambatan", 
    result : "Hasil",
    start_date : "Tanggal Mulai",
    date_end : "Tanggal Selesai",
    day : "Hari",  
    final_day1: "Tanggal Final",   
    subject : "Perihal",
    attachment : "Lampiran",
    penalty_value : "Nilai Denda Penalty",
    date_place: "Tempat, tanggal bulan tahun",
    issued_by: "Dikeluarkan Oleh",
    cp_pm : "Coordinator Project/ Project Manager",
    title_of_work:"Judul Pengerjaan",
    spo: "SPO",
    job_title : "Judul Pekerjaan",
    value : "Nilai",
    work : "Pekerjaan",
    contract_no: "Nomor Kontrak",
    initial_actual_percentage: "Persentase actual pekerjaan awal",
    persentase_pp: "Additional/Deducation Persentase",
    initial_value_contract: "Jumlah Awal Kontrak",
    nilai_pp: "Nilai",
    final_value_contract: "Actual Contract Amount (Rounding)",
    admin_pic: "PIC Admin Project",
    head_unit: "PIC Head Unit",
    type_Persentase : "Tipe Persentase",
    type_nilai : "Tipe Nilai",
    task : "Task",
    sch_date : "Sch Date",
    act_date : "Act Date",
    remarks : "Remarks",
    completion_time : "Waktu Penyelesaian",
    tgl_penerimaan : "Tanggal Penerimaan",
    accept_pekerjaan : "Status Pekerjaan",
    tgl_spo :"Tanggal SPO",
    date : "Tanggal",
    currently: "Currently",
    previously : "Previously",
    inspection : "Inspection",
    all_location : "Semua Lokasi",
    issue : "Issue",
    rectification: "Rectification",
    date_time : "Date/Time",
    area_plant: "Area Plant",
    report_number : "Nomor Dokumen",
    inspector : "Inspector",
    contractor_title : "Contract Title",
    accept_repair : "QC Status",
    days: "Days",
    comments : "Comments",
    date_Of_sign :"Date Of Sign",
    project_qc : "Project Quality Control",
    project_qc_head: "Project QC Head",
    request_date : "Tgl. Permintaan",
    approval_transaction : "Persetujuan Transaksi",
    type_spo : "Tipe SPO",
    baik_spo : "BAIK with SPO",
    baik : "BAIK with out SPO",
    kom : "Doc Kom",
    delay : "BA Delay",
    penalty : "BA Penalty",
    addendum : "Addendum",
    basttermin : "BAST Termin",
    qc : "Doc Qc Final",
    bastfinal:"BAST Final",
    from : "Dari",
    to : "Sampai",
    from_date : "From Date",
    to_date : "To Date",
    is_urgent_main_data : "w/o SPO",
    download_currently : "Download Currently",
    download_inspection : "Download Inspection",
    format_email :"Invalid Format Email",
    view : "View",
    edit : "Edit",
    delete : "Delete",
    month : "Bulan",
    inspection_previosly : "Inspection Previously",
    inspection_currently : "Inspection Currently",
    company_code : "Kode Perusahaan",
    recitified_day : "Rectified Day(s)",
    percent : "Persen", 
    tanggal_selesai : "Tanggal Selesai",
    rev_addendum : "Rev Addendum",
    rev_final : "Rev Final",
    rev_spo : "Rev BAIK SPO",
    rev_baik : "Rev BAIK",
    rev_kom : "Rev Doc KOM",
    rev_delay : "Rev Delay",
    rev_penalty : "Rev Penalty",
    rev_termin : "Rev Termin", 
    rev_qc : "Rev QC",
    rev : "Rev",
    count_day_penalty:"Jumlah hari Penalty",
    child_termin : "Sub BAST Termin",
    child_BAIK_SPO : "Sub BAIK with SPO",
    child_KOM : "Sub Kick Off Meeting",
    child_Progress_Termin : "Sub Progress Report Termin",
    child_MC : "Sub MC",
    child_BAPVA : "Sub BAPVA",
    child_RKTKA : "Sub RKTKA",
    child_MC_Addendum : "Sub MC Addendum",
    child_QC_Final : "Sub QC Final",
    child_BA_Delay : "Sub BA Delay",
    child_BA_Penalty : "Sub BA Penalty",
    child_BA_Final : "Sub BA Final",
    child_BA_Retensi : "Sub BA Retensi",
    project_qc_sipil : "Project QC Sipil",
    project_qc_mekanikal : "Project QC Mekanikal",
    project_qc_electrical : "Project QC Electrical",
    child_qc : "Sub QC Final",
    qc_electrical : "Project QC Electrical",
    qc_sipil : "Project QC Sipil",
    qc_mekanikal : "Project QC Mekanikal",
    creation_date : "Tanggal Pembuatan",
    edit_date : "Tanggal Pengeditan",
    deletion_date : "Tanggal Penghapusan",
    summary_report : "Laporan Ranguman - Dokumen Projek",
    report_generate_date : "Tanggal Pembuatan (Laporan/Dokumen)",
    bastretensi : "BAST Retensi",
    rev_retensi : "Rev Retensi",
    project_manager : "Project Manager",
    project_coordinator : "Project Coordinator",
    progess_report : "Laporan Progress - Dokumen Projek",
    progess_report_wo : "Laporan Progress - Work Order",
    persentase_cut_off : "Pemotongan Sedang Berlangsung (%)",
    lead_engineer : "Lead Engineering",
    kom_qc : "Doc KOM QC",
    rev_kom_qc : "Rev KOM QC",
    progress : "Progress",
    inspection_no : "No Inspeksi",
    new_document : "Total Dokumen Baru",
    penalty_days : "Jumlah Hari Dikenakan Denda",
    penalty_percentage : "Persentase Denda Per hari (‰)",
    total_penalty_value :"Total Nilai Denda",
    max_penalty_value : "Maximum Nilai Denda",
    total_penalty_charged : "Total Nilai Denda",
    log_date : "Log Date",
    id : "Item",
    Work_Group : "Group Pekerjaan",
    Usrnm_Head_User : "Head User (Release)",
    Usrnm_Lead_Engineering : "Lead Engineering (Release)",
    Usrnm_Head_Project_Dept : "Head Project Department (Release)",
    Usrnm_PIC_Engineering_Closing : "PIC Engineering (Closing)",
    Usrnm_Head_User_Closing : "Head User (Closing)",
    Usrnm_Head_Project_Dept_Closing : "Head Project Department (Closing)",
    Work_Description : "Deskripsi Kerja",
    Target_Date : "Target Selesai",
    WBS_Allocation : "WBS Allocation",
    Usrnm_PM_Closing : "Project Manager (Closing)",
    HEAD_DEPT : "Head Department",
    LEAD_ENGINEERING : "Lead Engineering",
    HEAD_USER : "Head User",
    Approval_Wo : "Approval WO",
    Picture_Before : "Gambar Sebelum",
    download_before : "Ungggah Sebelum",
    Picture_After : "Gambar Setelah",
    download_after : "Unggah Setelah",
    show_when_print : "Show When Print",
    Target_Reschedule : "Target Jadwal Ulang",
    Start_Work : "Pekerjaan Mulai",
    Finish_Work : "Pekerjaan Selesai",
    requester : "Peminta",
    Closed_Date : "Tanggal Tutup WO", 
    Currency : "Mata Uang",
    lock : "Lock",
    Contractor_Level : "Level Kontraktor",
    Administrator : "Administrator",
    Job_Role : "Job Role",
    is_main : "Main",
    Link_Main_Wo : "Link Main WO",
    main_data : "Main Data",
    Reason_Edit : "Alasan untuk di Edit",
    Change_History : "Log Perubahan",
    Is_Additional: "Addendum",
    Work_Order_Id : "Main WO",
    Doc_QC_Detail : "Inspections",
    Doc_QC_Inspection_Photos : "Inspections Photos",
    Doc_QC_Partcipants : "Partcipants",
    Work_Order : "Work Order",
    Work_Order_Detail : "Progressing",
    Doc_BA_Addendum : "BA Addendum",
    Doc_BA_Addendum_Reason : "BA Addendum Reason",
    Doc_BA_Addendum_Scope : "BA Addendum Scope",
    Doc_BA_Delay : "BA Delay",
    Doc_BA_Delay_Late : "BA Delay Late",
    Doc_BA_Final : "Doc BA Final",
    Doc_BA_Final_Evaluasi : "Doc BA Final Evaluasi",
    Doc_BA_Final_Progress : "Doc BA Final Progress",
    Doc_BA_Penalty : "Doc BA Penalty",
    Doc_BA_Penalty_Work : "Doc BA Penalty Work",
    Doc_BA_Retensi : "Doc BA Retensi",
    Doc_BA_Retensi_Evaluasi : "Doc BA Retensi Evaluasi",
    Doc_BA_Retensi_Progress : "Doc BA Retensi Progress",
    Doc_BA_Termin : "Doc BA Termin",
    Doc_BA_Termin_Evaluasi : "BA Termin Evaluasi",
    Doc_BA_Termin_Progress : "BA Termin Progress",
    Doc_BAIK : "BAIK With Out",
    Doc_BAIK_Reason : "BAIK With Out Reason",
    Doc_BAIK_Scope : "BAIK With Out Scope",
    Doc_BAIK_SPO : "BAIK With SPO",
    Doc_BAIK_SPO_Reason : "BAIK With SPO Reason",
    Doc_BAIK_SPO_Scope : "BAIK With SPO Scope",
    Doc_KOM : "Doc KOM",
    Doc_KOM_Company : "Doc KOM Company",
    Doc_KOM_Contractor : "Doc KOM Contractor",
    Doc_KOM_Item: "Doc KOM Item",
    Doc_KOM_QC : "Doc KOM QC",
    Doc_QC : "QC Final",
    Doc_QC_Detail : "QC Final Detail",
    Main_Data : "Main Data",
    Status_Release : "Release Status",
    Release_Date : "Release Date",
    Progressing_Status : "Progressing Status",
    
    Currency_Code : "Currency",
    Doc_Date : "Document Date",
    Tanggal_Mulai_Pekerjaan : "Job Start Date",
    Job_Role: "Job Role",
    Action_By : "Action By",
    Date_Action_Required : "Date Action Required",
    Sch_Date : "Sch Date",
    Act_Date : "Act Date",
    Tanggal_Penerimaan : "Received Date",
    Type_Persentase : "Percentage Type",
    Persentase_PP : "Additional/Deduction Percentage",
    Nilai_Akhir_Kontrak : "Final Contract Value",
    Type_Nilai : "Value Type",
    Date_Time : "Date Time",
    Username_Inspector : "Username Inspector",
    Username_QC_Mekanikal : "Project QC Mechanical",
    Username_QC_Electrical : "Project QC Electrical",
    Username_QC_Civil : "Project QC Civil",
    Inspection_Currently : "Inspection Currently",
    Inspection_Previosly : "Inspection Previously",
    Log_Date : "Log Date",
    Hari_Tanggal : "Document Date",
    Tanggal_Final : "QC Inspection FInal Date",
    Jumlah_Hari_Keterlambatan : "Number of Delay Days",
    Jumlah_Hari_Penalty : "Number of Penalty Days",
    Jumlah_Hari : "Number Of Days",
    Username_PM_PIC_Company : "PIC Project Manager",
    Tanggal_Mulai : "Start Date",
    Tanggal_Selesai : "End Date",
    Hari_Tanggal_Input : "Document Date",
    Rason : "Delay Reason",
    Penalty_Percentage : "Penalty Percentage",
    Total_Penalty_Value : "Total Penalty Value",
    Total_Penalty_Charged : "Total Penalty Charged ",
    Penalty_Days : "Penalty Days(s)",
    Rason : "Delay",
    Total_Days : "Total Days",
    Nilai_Kontrak : "Contract Value",
    Username_Project_Manager : "Project Manager",
    Currency_Code : "Currency",
    No_SPK : "No SPK",
    SPO_Date : "SPO Date",
    No_SPR	: "No SPR",
    No_SPO : "No SPO",
    summary_report_wo : "Laporan Rangkuman - Work Order",
    Doc_No : "Doc No",
    
    Tanggal_Penerimaan : "Received Date",
    Username_PIC_PM : "Project Manager",
    Username_PIC_Contractor : "Project Manager Contractor",
    Meeting_No : "Meeting No",
    Issued_Date : "Issed Date",
    Meeting_Room : "Meeting Room",
    Date_Of_Meeting : "Date Of Meeting",
    Notes_Issued_By : "Notes Issued By",
    Approved_By : "Approved_By",
    Nilai_PP : "Amount",
    Is_Check : "Check",
    Report_Number : "Report Number",
    Accept_Repair : "Accept Repair",
    Persentase_Cut_Off : "Deviation of Contract Value (%)",
    Job_Start_Date : "Tanggak Mulai Kerja",
    Planned_Start_Date : "Planned Start Date",
    Planned_Finish_Date : "Planned Finish Date",
    Act_Start_Date : "Act Start Date",
    Act_Finish_Date : "Act Finish Date",
    Migration_Data : "Migration Data",
    Usrnm_PIC_AR_Closing : "PIC Creator AR (Closing)",
    Usrnm_Lead_Engineering_Closing : "Lead Engineering (Closing)",
    Is_Tendering_Completed:"Tendering Completed",
    By_Engineering : "By Engineering",
    PIC_Engineering : "PIC Engineering",
    Usrnm_PM : "Project Manager",
    Usrnm_Prj_Coordinator : "Project Coordinator",
    Usrnm_Head_Unit : "Head Unit",
    Usrnm_Site_Manager : "Site Manager",
    Usrnm_Qc_Head : "QC Head",
    Usrnm_PM_Contractor : "Project Manager Contractor",
    AddScope : "Additional Scope",
    DeducationScope : "Deduction Scope",
    Sign_Position : "Sign Position",
    'PROJECT MANAGER CONTRACTOR': "Project Manager Contractor",
    'PROJECT MANAGER' : "Project Manager", 
    'PROJECT COORDINATOR' : "Project Coordinator",
    'SITE MANAGER' : "Site Manager", 
    'QC HEAD' : "QC Head", 
    'HEAD UNIT' : "Head unit",
    WO_Type : "WO Type",
    Usrnm_Section_Head : "Section Head",
    Item_SPR : "Item SPR",
    Item_SPO : "Item SPO",
    Last_Pending_On : "Last Pending On",
    Valid_Date : "Valid Date",
    Name_Comp : "Company Name (Update)",
    Valid_From : "Valid From",
    
    UpdateWO : "Update Status WO",
    logprocess : "Proses Log",
    Trigger_Code : "Trigger Code",
    Doc_Date_From : "Dari Tanggal",
    required_field : "Field ini wajib diisi",
    Trigger_By : "Di Trigger Oleh",
    Trigger_Date : "Tanggal Di Trigger",
    JSON_Structure : "Struktur JSON",
    document_name : "Nama Dokumen",
    Documentation : "Dokumentasi",
    PIC_WO : "PIC Work Order",
    Duration : "Durasi",
    Attachment : "Lampiran",
    BoQ : "Bill of Quantity",
    material_price : "Harga Material",
    labour_price : "Harga Tenaga Kerja",
    initial_contract : "Kontrak Awal",
    MC0 : "MC-0",
    MC100 : "MC-100",
    MC_Between : "MC di Antara",
    Volume : "Volume",
    Amount : "Jumlah",
    Deviasi : "Deviasi",
    RKTK_MC0 : "RKTK MC-0",
    RKTK_MC100 : "RKTK MC-100",
    RKTK_MC_Between : "RKTK MC di Antara",
    Contract_MC0 : "Kontrak MC-0",
    Contract_MC100 : "Kontrak MC-100",
    Contract_MC_Between : "Kontrak MC di Antara",
    Total_Amount : "Jumlah Total",
    Final_Total_Amount : "Jumlah Total Akhir",
    Link_Work_Order : "Link Work Order",
    wo_type : "WO Type",
    wo_No : "WO No",
    link_mc : "Link From MC",
    SPO_No : "SPO No",
    SPO_Item : "SPO Item",
    Usrnm_Quantity_Surveyor : "Quantity Surveyor",
    Usrnm_QS_Contractor : "Quantity Surveyor Contractor",
    Usrnm_Admin_Project: "Admin Project",
    Usrnm_Project_Engineer : "Project Engineer",
    Usrnm_Factory_Manager : "Factory Manager",
    Usrnm_Operation_Head : "Operation Head",
    Usrnm_Site_PIC : "Site PIC",
    Total_Contract_Amount_BoQ : "Total Contract Amount (Base on Actual BoQ)",
    Total_Contract_Amount_SAP : "Total Contract Amount (Base on SAP)",
    Current_MC : "Current MC",
    Previous_MC : "Previous MC",
    volume : "Volume",
    Previous : "Previous",
    Current : "Current",
    Deviasi : "Deviation",
    BAPVA : "BAPVA",
    RKTKA : "RKTKA",
    ADDENDUM : "ADDENDUM",
    Addendum_MC : "Addendum MC",
    Total_Initial_Contract : "Total Initial Contract",
    Total_Actual_Contract : "Total Actual Contract",
    Rounding : "Rounding",
    Deviasi_Percent : "Deviation(%)",
    unit_price : "Unit Price",
    Material : "Material",
    Labour : "Labour",
    Final_Contract_Amount : "Final Contract Amount",
    Final_Contract_Amount : "Final Contract Amount",
    Total_Previous_Progress : "Progress Previous Total (%)",
    Total_Current_Progress : "Progress Current Total (%)",
    Total_To_Date_Progress : "Progress To Date (%)",
    Progress_To_Charge : "Progress To Charge (%)",
    progress_previous : "Progress Previous",
    progress_current : "Progress Current",
    progress_to_date : "Progress To Date",
    MC_Number : "Link MC",
    New_SPO : "New SPO",
    parent : "Parent",
    Pur_Org : "Purchase Organization",
    Active_SAP : "Active SAP",
    Adopt_SAP : "Adopt SAP",
    MC : "MC",
    RKTK : "RKTK",
    BAPVA : "BAPVA",
    Progress_Termin : "Progress Termin",
    Progress_Final : "Progress Final",
    previous_process : "Last Process Document",
    Approved_Date : "Approved Date",
    next_process : "Next Process Document",
    status_document : "Status Document",
    Wo_Creation : "Work Order Creation",
    Wo_Closing : "Work Order Closing",
    Invoice_No : "Contractor Invoice No",
    Status_Payment : "Payment Status",
    MC0_STATUS : "MC-0",
    MC_BETWEEN_STATUS : "MC-Between",
    MC100_STATUS : "MC-100",
    BAPVA_MC0_STATUS : "BAPVA MC-0",
    BAPVA_MC_BETWEEN_STATUS : "BAPVA MC-Between",
    BAPVA_MC100_STATUS : "BAPVA MC-100",
    RKTK_MC0_STATUS : "RKTK MC-0",
    RKTK_MC_BETWEEN_STATUS : "RKTK MC-Between",
    RKTK_MC100_STATUS : "RKTK MC-100",
    ADDENDUM_MC0_STATUS : "ADDENDUM MC-0",
    ADDENDUM_MC_BETWEEN_STATUS : "ADDENDUM MC-Between",
    ADDENDUM_MC100_STATUS : "ADDENDUM MC-100",
    PROGRESS_TERMIN_STATUS : "PROGRESS TERMIN",
    PROGRESS_FINAL_STATUS : "PROGRESS FINAL",
    rev_MC0 : "Rev MC-0",
    rev_MC_BETWEEN : "Rev MC Between",
    rev_MC100 : "Rev MC-100",
    rev_BAPVA_MC0 : "Rev BAPVA MC-0",
    rev_BAPVA_MC_BETWEEN : "Rev BAPVA MC Between",
    rev_BAPVA_MC100 : "Rev BAPVA MC-100",
    rev_RKTK_MC0 : "Rev RKTK MC-0",
    rev_RKTK_MC_BETWEEN : "Rev RKTK MC Between",
    rev_RKTK_MC100 : "Rev RKTK MC-100",
    rev_ADDENDUM_MC0 : "Rev ADDENDUM MC-0",
    rev_ADDENDUM_MC_BETWEEN : "Rev ADDENDUM MC Between",
    rev_ADDENDUM_MC100 : "Rev ADDENDUM MC-100",
    rev_PROGRESS_TERMIN : "Rev PROGRESS TERMIN",
    rev_PROGRESS_FINAL : "Rev PROGRESS FINAL",
    date_mc : "Date of MC",
    verification_date : "Verification Date",
    phone_number : "Phone Number",
    contact_person : "Contact Person",
    not_viewed : "Not Viewed",
    Deleted : "Delete",
    contract : "Contract",
    amount : "Amount",
    request_by : "Request By",
    request_date : "Request Date",
    modul : "Module",
    Contract_Amount_New_SPO : "Contract Amount for New SPO",
    Contract_Amount_Initial_SPO : "Contract Amount for Initial SPO",
    Contract_Adjust : "Lastest Contract (for Adjust Price)",
    Calculate : "Calculate",
    Contract_Amount : "Contract Amount",
    SPO_Category_Type : "SPO Category No",
    code_contractor : "Contractor Code",
    only_draft : "Only Draft",
    Initial_Instruction : "Initial Instruction",
    Instruction_BaseMC : "Instruction Base on MC",
    message:{
        reset_confirmation: "Apakah data penilaian ingin di reset",
        revised_confirmation: "Apakah data ingin di revisi",
        approve_confirmation: "Apakah data ingin di approve",
        reject_confirmation: "Apakah data promosi ingin di reject",        
        sync_confirmation: "Apakah anda yakin ? Data penilaian yang dipilih ini akan dikirm ke SAP HCM",
        sync_all_confirmation: "Apakah anda yakin untuk mengirim semua data appraisal ke SAP HCM ?",
    },

    note: {
        history: "Catatan : Data penilai diurutkan dari bawah ke atas (Data paling atas adalah data terbaru). Dapat dilihat dari tanggal dan jam pada kolom 'Input Date'",
        mydata: "Catatan : Baris yang diwarnai hijau adalah karyawan yang penilaiannya sudah dinilai oleh Komite",
        listAssed: "Catatan untuk Admin Unit : Untuk penilaian karyawan yang sudah di-edit atau di-upload oleh Admin HO, maka tombol edit tidak tersedia di kolom karyawan tsb",
        employee: "Catatan : Karyawan yang ditampilkan adalah karyawan yang tidak dalam (PHK, Terminasi & Expatriate), join di atas atau melewati tanggal 1-Juli-Tahun, dan golongan 10 yaitu direktur",
        reset: "Catatan : Data yang di reset adalah data penilaian terakhir !",
        cancel_promot: "Jika anda membatalkan permintaan promosi ini, anda masih dapat memintanya lagi di SAP Fiori",
        upload: " boleh digandakan dan boleh memasukkan kode baru. Jika kode sudah ada (duplikat), maka data sebelumnya akan diperbaharui"
    },

    acceptpekerjaan : {
        menerima : "Menerima, pekerjaan telah dilaksanakan sesuai dengan instruksi dari pelaksana project",
        tidak_menerima : "Tidak bisa menerima, kontraktor harus membongkar dan atau memperbaiki dalam waktu 2 (dua) minggu"
    },

    messagebox:{
        cutoff : "Mohon input persentase progress ketika dilakukannya cut off"
    }
}

export default message;